import { render, staticRenderFns } from "./UnitList.vue?vue&type=template&id=c4b91e16&scoped=true"
import script from "./UnitList.vue?vue&type=script&lang=js"
export * from "./UnitList.vue?vue&type=script&lang=js"
import style0 from "./UnitList.vue?vue&type=style&index=0&id=c4b91e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b91e16",
  null
  
)

export default component.exports